import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { jwtDecode } from 'jwt-decode';
import ls from 'localstorage-slim';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sign } from 'src/app/shared/components/signature/signature';
import { generateTimestamp } from 'src/app/shared/utils/date.utils';
import { AppState } from 'src/app/store';
import { environment } from '../../../../environments/environment';
import {
  acceptLanguage,
  AUTHORIZATION,
  SECRET_KEY,
  X_CLIENT_ID,
  X_CLIENT_TYPE,
  X_PLATFORM_TYPE,
  X_SIGNATURE,
  X_TIMESTAMP
} from '../../../app.constants';
import { reduxReset } from '../../../store/actions/root/root.actions';
import { Authentication } from '../models/authentication.model';
import { OTPCredentials } from '../models/otp-credentials.model';
import { PlatformType } from './../../../enums/platform-type.enum';
ls.config.encrypt = true;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  httpReqError = new BehaviorSubject<string>('');
  decodedToken: { [key: string]: string };
  loginSign = {};

  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store<AppState>
  ) {
    this.decodedToken = {};
  }

  login(
    credentials: OTPCredentials,
    currentLang?: any
  ): Observable<HttpResponse<Authentication>> {
    let timestamp = generateTimestamp();
    this.loginSign = {
      userCode: credentials.userCode,
      otp: credentials.otp,
      platformType: PlatformType.WEB,
      publicKey: credentials.publicKey,
      timestamp: timestamp,
      secret: SECRET_KEY
    };
    const signature = Object.values(this.loginSign).join('|');

    const headers = new HttpHeaders()
      .set(X_TIMESTAMP, timestamp)
      .set(X_PLATFORM_TYPE, PlatformType.WEB)
      .set(acceptLanguage, currentLang)
      .set(X_SIGNATURE, sign(signature));
    return this.http.post<Authentication>(
      `${environment.baseUrl}/auth/otp-login`,
      credentials,
      { headers, observe: 'response' }
    );
  }

  getToken(): string {
    return ls.get(AUTHORIZATION) || '';
  }

  decodeToken() {
    if (this.getToken()) {
      this.decodedToken = jwtDecode(this.getToken());
    }
  }
  getDecodeToken() {
    return jwtDecode(this.getToken());
  }

  getClientId(): string {
    return ls.get(X_CLIENT_ID) || '';
  }

  getClientType(): string {
    return ls.get(X_CLIENT_TYPE) || '';
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }

  isProfileSelected(): boolean {
    const clientId = this.getClientId();
    return !!clientId;
  }

  getAutoLogout() {
    return localStorage.getItem('autoLogout') == 'true';
  }

  setAutoLogout(autoLogout: boolean) {
    localStorage.setItem('autoLogout', autoLogout.toString());
  }

  logout(): void {
    let lang = localStorage.getItem('language');
    localStorage.clear();
    if (lang) localStorage.setItem('language', lang);
    this.store.dispatch(reduxReset());
    this.router.navigateByUrl('/login');
  }

  logoutApi(): Observable<any> {
    return this.http.post(`${environment.baseUrl}/auth/logout`, null).pipe(
      map(response => {
        return response;
      })
    );
  }
}
